<template>
  <div class="page print-info-area fs13 p20 mb-4">
    <PDFHeader :title="$t('home_care_notebook')"/>
    <div class="home-care-table">
      <div class="table-image-area">
        <div class="title-list-image">画像</div>
        <div class="list-image">
          <p v-if="listImage == null || listImage.length == 0">画像のデータがありません</p>
          <template v-else>
            <template v-for="(img_url, index) in listImage">
              <img
                v-if="index < 2" :key="tableName+'_img_'+index"
                :src="img_url"
                :style="[(listImage.length == 1 ? {maxWidth: '100%'} : ''),{maxHeight: '875px'}]"
                />
            </template>
          </template>
        </div>
      </div>
    </div>
    <hr v-if="isShowEndline" class="float-left w-100">
  </div>
</template>
<script>
import PDFHeader from '../PDFHeader.vue'
export default {
  components: {
    PDFHeader,
  },
  props: [
    'tableName',
    'listImage',
    'isShowEndline',
  ],

}
</script>
<style scoped>
  .list-image {
    max-height: 900px;
  }
</style>
